import React, { useState } from 'react';
import Autosuggest from 'react-autosuggest';

import './style.scss';

const ApiAutocomplete = ({ endpoint, placeholder, renderItem, defaultValue, onSelectItem, queryParameter = 'q', onChange = () => { }, ...props }) => {
  const [queryInput, setQuery] = useState(defaultValue || '');
  const [results, setResults] = useState([]);

  const getSuggestions = (query) => {
    const url = `${endpoint}?${queryParameter}=${query}`;

    fetch(url)
      .then((response) => { return response.json(); })
      .then((response) => {
        const ajaxResults = response.map((item, index) => {
          item.value = index;
          return item;
        });
        setResults(ajaxResults);

      });
  };

  return (
    <Autosuggest
      suggestions={results}
      onSuggestionsFetchRequested={({ value, reason }) => {
        getSuggestions(value);
      }}
      onSuggestionsClearRequested={() => {
        setResults([]);
      }}
      getSuggestionValue={(item) => {
        return item.name;
      }}
      renderSuggestion={(item, attributes) => {
        return renderItem(item, attributes.isHighlighted);
      }}
      onSuggestionSelected={(event, { suggestion }) => {
        onSelectItem(suggestion);
      }}
      inputProps={{
        ...props,
        placeholder,
        value: queryInput,
        onBlur: (event) => {
          const value = event.target.value;
          if (!value || value.length === 0) {
            onSelectItem('');
          }
        },
        onChange: (event, { newValue }) => {
          setQuery(newValue);
          onChange();
        },
      }}
    />
  );
};

export default ApiAutocomplete;
